<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="creditUsageContainer">
  <div class="modal-header">
    <div class="modal-title" [xdaTranslate]="'SDE_CREDIT_USAGE'"></div>
    <div class="modal-close">
      <button
        type="button"
        class="modal-close-btn"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true" class="xgl-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" tabindex="-1">
    @if (loading) {
      <div id="credits-loading" class="blanket">
        <div class="flex-center">
          <span class="xrx-activity-indicator ai-lg ai-spin"></span>
        </div>
        <div class="flex-center mt-5">
          <span xdaTranslate>SDE_RETRIEVING_USAGE_DATA</span>
        </div>
      </div>
    }
    @if (!loading) {
      <div class="show-desktop">
        <div class="row">
          <div class="col-md-6" tabindex="-1">
            <xrx-select
              label="SDE_DATE_RANGE"
              [(list)]="dateRange"
              property="value"
              localize="SDE_KEY"
              (change)="onDateRangeSelected()"
              [(selectedItem)]="selectedDateRange"></xrx-select>
          </div>
          <div class="col-md-6">
            <button
              class="xrx-btn btn-secondary refreshBtn"
              [disabled]="refreshDisabled"
              (click)="refresh()"
              [xdaTranslate]="'SDE_REFRESH'"></button>
          </div>
        </div>
        @if (accessListUsers && accessListUsers.length) {
          <div class="creditUsageTable table-responsive scrollable">
            <table class="table table-sort">
              <thead>
                <tr>
                  <th
                    scope="col"
                    sortable="userFirstName"
                    direction=""
                    [(data)]="accessListUsers">
                    <span xdaTranslate>SDE_USER</span>
                  </th>
                  <th
                    scope="col"
                    class="sort-active"
                    sortable="displayTotal"
                    sorttype="number"
                    direction="asc"
                    [(data)]="accessListUsers">
                    <span
                      [xdaTranslate]="'SDE_CREDITS_USED_FMTSTR'"
                      [formatValues]="
                        displayTotal === 0 ? '0' : displayTotal.toString()
                      "></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (user of accessListUsers; track user) {
                  <tr>
                    <td>
                      <div class="user-name">
                        {{ user.userFirstName }} {{ user.userLastName }}
                      </div>
                      <div class="user-email">{{ user.userEmail }}</div>
                    </td>
                    <td class="align-middle">
                      <div class="leftbox">{{ user.displayTotal }}</div>
                      <div class="rightbox progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          [ngStyle]="{
                            width: user.displayPct + '%',
                            visibility:
                              user.displayPct > 0 ? 'visible' : 'hidden',
                          }"
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <div>
          <button
            class="xrx-btn btn-secondary"
            (click)="downloadCSV()"
            xdaTranslate>
            SDE_DOWNLOAD_CSV
          </button>
          <button
            class="xrx-btn btn-primary float-right"
            (click)="activeModal.dismiss()"
            xdaTranslate>
            SDE_CLOSE
          </button>
        </div>
      </div>
    }
    @if (!loading) {
      <div class="show-mobile">
        <div class="row">
          <div class="col-sm-6">
            <xrx-select
              label="SDE_DATE_RANGE"
              [(list)]="dateRange"
              property="value"
              localize="SDE_KEY"
              (change)="onDateRangeSelected()"
              [(selectedItem)]="selectedDateRange"></xrx-select>
          </div>
          <div class="col-sm-6">
            <button
              class="xrx-btn btn-secondary refreshBtn"
              (click)="refresh()"
              [xdaTranslate]="'SDE_REFRESH'"></button>
          </div>
        </div>
        @if (accessListUsers && accessListUsers.length) {
          <div class="creditUsageTable table-responsive scrollable">
            <table class="table table-sort">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="sort-active"
                    sortable="displayTotal"
                    sorttype="number"
                    direction=""
                    [(data)]="accessListUsers">
                    <span
                      [xdaTranslate]="'SDE_CREDITS_USED_FMTSTR'"
                      [formatValues]="
                        displayTotal === 0 ? '0' : displayTotal.toString()
                      "></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (user of accessListUsers; track user) {
                  <tr>
                    <td>
                      <div class="leftcol">
                        <div class="user-name">
                          {{ user.userFirstName }} {{ user.userLastName }}
                        </div>
                        <div class="user-email">{{ user.userEmail }}</div>
                      </div>
                      <div class="rightcol">
                        <span>{{ user.displayTotal }}</span>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <div>
          <button
            class="xrx-btn btn-secondary"
            (click)="downloadCSV()"
            xdaTranslate>
            SDE_DOWNLOAD_CSV
          </button>
          <button
            class="xrx-btn btn-primary float-right"
            (click)="activeModal.dismiss()"
            xdaTranslate>
            SDE_CLOSE
          </button>
        </div>
      </div>
    }
  </div>
</div>
